import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: #DFE2EB;
    z-index: 2;
  }
`;

export const SnappyAnimation = styled.img`
  position: relative;
  width: 150px;
  height: 74px;
  z-index: 1;
`;
